import React from 'react';
import 'antd/dist/antd.variable.min.css';
import './App.css';
import './theme/shadcn.css';
import { applyAntdTheme } from './theme/antdTheme';
import { MenuComponent } from 'components/MenuComponent';

applyAntdTheme();

function App() {
  return <MenuComponent />;
}

export default App;
